import MuiDialogContentText, {
  DialogContentTextProps as MuiDialogContentTextProps
} from '@mui/material/DialogContentText';
import * as React from 'react';

import { Markup } from '../Markup/Markup';

type DialogContentTextProps = MuiDialogContentTextProps;

export const DialogContentText = (props: DialogContentTextProps) => {
  return <MuiDialogContentText {...props} />;
};

export type DialogContentTextOrMarkupProps = {
  text: string;
  /** @default false */
  renderMarkup?: boolean;
  whiteSpace?: DialogContentTextProps['whiteSpace'];
};

export const DialogContentTextOrMarkup = (props: DialogContentTextOrMarkupProps) => {
  const { renderMarkup, text, whiteSpace } = props;
  if (renderMarkup) {
    return <Markup typographyProps={{ sx: { whiteSpace } }} content={text} />;
  } else {
    return <DialogContentText whiteSpace={whiteSpace}>{text}</DialogContentText>;
  }
};
